export default __webpack_public_path__ + "46beb38.png";